export const LanguagesInLondon = [
  {
    heading: "Certified",
    detail:
      " Tomedes provides <a href='/certified-translation.php' class='text-orange hover:text-newOrange-100 transition-colors'>certified translation</a> services that make sure that your translations are an authentic and accurate representation of the original. Our certified translators create translations of official documents for institutions in the UK and abroad. At Tomedes, we assist you in all aspects of your application, aside from making sure that your translations are reliably certified.",
    secondHeading: "Translation Services",
  },
  // {
  //   heading: "Spanish",
  //   detail:
  //     " A huge number of Chicago's population speaks Spanish, with Spanish being the number one language spoken at home in Chicago. Translation services can better serve the community of Chicago with Spanish to English or vice versa translations for businesses or individual clients. Reach out for more.",
  //   link: "/spanish-translation.php",
  //   secondHeading: "Translation Services",
  // },
  {
    heading: "Interpreting",
    extraHead: " ",
    secondHeading: "Services",
    extraLink: " ",
    pad: " ",
  },
  {
    heading: "Video Remote ",
    detail:
      "Tomedes also offers video remote interpretation, gaining a reputation as a state-of-the art interpreting agency in London. We offer Zoom interpreting services, as well as interpreting services for other types of video conferencing platforms. We serve the multilingual needs of any community, as well as the needs of the deaf and hard-of-hearing.",
    link: "/services/video-remote-interpreting",
    secondHeading: "Interpretation",
  },
];
export const DemandInChicago = [
  {
    heading: "Arabic",
    detail:
      "According to British press, about 17,000 have the Arabic language as their mother tongue and speak it commonly at home. The Arabic language is also spoken by 422 million speakers in the world. If you're looking for Arabic translation or interpreting services, make sure to reach out today.",
    link: "/arabic-translation.php",
  },
  {
    heading: "Japanese",
    detail:
      "There are about 34,000 Japanese speakers in Greater London alone. If you'd like to reach out to this consumer base, why not do so with Japanese translation services at Tomedes? Japanese is also used majorly by businesses around the world, so translating or interpreting in the Japanese language may prove useful.",
    link: "/japanese-translation.php",
  },
  {
    heading: "Spanish",
    detail:
      "In London, Spanish translation services can come in handy when reaching out to the 44,307 Spanish speaking consumers, and beyond. Spanish is one of the major languages of the world, as well, which is why translation or interpreting services from English to Spanish or Spanish to English can broaden the scope of your business.",
    link: "/spanish-translation.php",
  },
  {
    heading: "Chinese",
    detail:
      "Chinese translation services may come in handy, if you're looking for Chinese to English and English to Chinese translations. Choose from over 120 languages and make sure you're reaching this major demographic in London, which comprises about 120,250 residents.",
    link: "/mandarin-chinese-translation",
  },
  {
    heading: "French",
    detail:
      "With France as a neighborhood of England, French is spoken by 250,000 residents in London. French, a major language of Europe, can be translated into any other European language to suit the needs of businesses and individuals in London. Get started today.",
    link: "/french-translation.php",
  },
  {
    heading: "Polish",
    detail:
      "London's Polish-speaking residents are 546,000. Tomedes translators have the skills of both spoken and written Polish, perfect if you're looking for interpretation, localization and translation services in London. Translations from Polish to English or English to Polish, or any other language, can easily be done.",
    link: "/polish-translation.php",
  },
];
